import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  z-index: 2;
  right: 2rem;
  top: 2rem;
  width: 35rem;
`;

export const ToastItem = styled.div`
  padding: 2rem;
  background: #22d827;
  color: white;
  border-radius: 0.5rem;
  box-shadow: 0 0.3rem 2rem 0 rgba(106,95,199,0.3);
  font-size: 1.4rem;
  margin-bottom: 1rem;
`;